import { ReactNode } from "react";
import { CapabilityEnum } from "utils/enums/CapabilityEnum";
import { BasePermissionCapability } from "./BasePermissionCapability";

export abstract class BasePermissionMenu {
  key?: string;
  name?: string;
  code?: string;
  path?: string;
  enable?: boolean;
  order?: string;
  componentName?: string;
  icon?: string | ReactNode;
  capabilities?: Array<BasePermissionCapability>;
  sub?: Array<BasePermissionMenu>;
  configuration?: Record<string, unknown>;

  constructor(data?: Partial<BasePermissionMenu>) {
    this.key = data?.key;
    this.name = data?.name;
    this.code = data?.code;
    this.path = data?.path;
    this.enable = data?.enable;
    this.order = data?.order;
    this.componentName = data?.componentName;
    this.icon = data?.icon;
    this.order = data?.order;
    this.capabilities = data?.capabilities;
    this.sub = data?.sub;
    this.configuration = data?.configuration;
  }

  protected isHasMainList(): boolean {
    return (
      !!this.capabilities &&
      this.capabilities?.some((item) =>
        item?.key?.includes(CapabilityEnum.list),
      )
    );
  }

  protected isHasGeneralList(): boolean {
    return (
      !!this.capabilities &&
      this.capabilities?.some((item) => item?.key === CapabilityEnum.general)
    );
  }

  protected validatePermission(featureKey: string[]): string[] {
    return featureKey.filter((key) =>
      this.capabilities?.some((cap) => cap.key === key),
    );
  }

  protected hasCapability(key: string) {
    return this.capabilities?.some((item) => item?.key?.includes(key));
  }
}
